<template>
    <v-container fluid>
        <v-card class="mb-4 overflow-visible" style="height:160px">
            <v-card-title>Job Item Description Search</v-card-title>
            <v-card-text>
                <v-row align="center" class="ga-2">
                    <v-col cols="12" sm="3">
                        <contact-search-input v-model="selectedContact" label="Filter by Customer..."></contact-search-input>
                    </v-col>
                    <v-col cols="12" sm="4" align-self="start">
                        <v-text-field v-model="searchText"
                                      label="Search description..."
                                      hide-details
                                      clearable
                                      prepend-inner-icon="mdi-magnify"
                                      @keyup.enter="runSearch"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2" align-self="start">
                        <v-checkbox v-model="includeCompleted"
                                    label="Include Completed"
                                    hide-details></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="auto" align-self="start">
                        <v-btn color="primary"
                               :loading="loading"
                               prepend-icon="mdi-magnify"
                               @click="runSearch">
                            SEARCH
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <v-card v-if="results !== null" class="position-static">
            <v-card-text>
                <div v-if="results.length === 0" class="text-center py-4 text-medium-emphasis">
                    No results found.
                </div>
                <v-table v-else density="compact">
                    <thead>
                        <tr>
                            <th class="text-left">Job</th>
                            <th class="text-left">Customer</th>
                            <th class="text-left">Description</th>
                            <th class="text-right">Qty</th>
                            <th class="text-right">Unit Price</th>
                            <th class="text-left">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in results" :key="item.id">
                            <td><job-link :job="item.job"></job-link></td>
                            <td><contact-link :contact="item.job.contact"></contact-link></td>
                            <td><span v-html="formatSearchName(item.description, searchText)"></span></td>
                            <td class="text-right">{{ item.quantity }}</td>
                            <td class="text-right">{{ numberWithCommas(item.discountedUnitPrice, 2) }}</td>
                            <td><type-chip :type="item.job.activeTask.status" entity="Job" :object="item.job" size="large" variant="text"></type-chip></td>
                        </tr>
                    </tbody>
                </v-table>
            </v-card-text>
        </v-card>
    </v-container>
</template>
<style scoped>
    :deep(.highlight-text) {
        background-color: #FFF176;
        font-weight: bold;
    }
</style>
<script>
    import { mapActions } from 'vuex';
    import { formatSearchName } from '../mixins/searchMixins';
    import { numberWithCommas } from '../mixins/numberMixins';
    function initialState() {
        return {
            loading: false,
            selectedContact: null,
            searchText: '',
            includeCompleted: false,
            results: null
        };
    }
    export default {
        name: "JobItemSearchReportView",
        data() {
            return initialState();
        },
        methods: {
            ...mapActions(['showErrorSnack']),
            formatSearchName,
            numberWithCommas,
            runSearch() {
                this.loading = true;
                const params = new URLSearchParams();
                if (this.selectedContact) {
                    params.append('contactId', this.selectedContact.id);
                }
                if (this.searchText && this.searchText.trim().length > 0) {
                    params.append('searchTerm', this.searchText.trim());
                }
                params.append('includeCompleted', this.includeCompleted);
                this.$api.get('report/jobitemsearch?' + params.toString())
                    .then(res => {
                        this.results = res.data;
                        this.loading = false;
                    })
                    .catch(() => {
                        this.showErrorSnack('There was an issue running the search.');
                        this.loading = false;
                    });
            }
        }
    };
</script>
